var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userType == 2)?_c('userDashBoard',{on:{"loadingChange":function (e){ return _vm.$emit('loadingChange',e); }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }